import { render, staticRenderFns } from "./SelectSpeciality.vue?vue&type=template&id=e05c0504&"
import script from "./SelectSpeciality.vue?vue&type=script&setup=true&lang=ts&"
export * from "./SelectSpeciality.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e05c0504')) {
      api.createRecord('e05c0504', component.options)
    } else {
      api.reload('e05c0504', component.options)
    }
    module.hot.accept("./SelectSpeciality.vue?vue&type=template&id=e05c0504&", function () {
      api.rerender('e05c0504', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/appointment/vrach/new/components/DoctorAppointmentForm/components/DoctorCard/components/SelectSpeciality.vue"
export default component.exports